import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

import { Edge } from "../../../../docuclipper/DocuclipperTypes";
import { Alert } from "react-bootstrap";
import Select from "react-select";
import uuidv4 from "uuid/v4";

type Props = {
  edge: Edge;
  onWordsChanged: (words: string[]) => any;
  onMenuOpen: () => any;
};
export const VariableLocationWords: React.SFC<Props> = ({
  edge,
  onWordsChanged,
  onMenuOpen,
}) => {
  let wordsElem: JSX.Element | null = null;
  const handleChange = (newValue: any, actionMeta: any) => {
    onWordsChanged((newValue || []).map((x) => x.value));
  };

  if (edge.words) {
    if (edge.words.loading) {
      wordsElem = <ClipLoader loading={true} />;
    } else {
      wordsElem = (
        <>
          {edge.words.error && (
            <Alert variant="danger">{edge.words.error}</Alert>
          )}
          <Select
            key={uuidv4()}
            onMenuOpen={onMenuOpen}
            isSearchable={false}
            menuIsOpen={false}
            placeholder="Select words ..."
            isMulti={true}
            value={edge.words.words.map((word) => ({
              value: word,
              label: word,
            }))}
            onChange={handleChange}
          />
        </>
        // <Form.Control readOnly={true} value={(edge.words.words || []).join(" ")} />
      );
    }
  }
  return <>{wordsElem}</>;
};
export default VariableLocationWords;
